(() => {
  const ANIMATION_DURATION = 250;
  const megaDetails = document.querySelectorAll(".js-mega-detail");
  let activeMegaDetail = null;
  let isAnimating = false;

  function resetCardAnimations(detail) {
    const cards = detail.querySelectorAll(".scroll-trigger");
    cards.forEach((card) => {
      card.classList.add("scroll-trigger--offscreen");
    });
  }

  function triggerCardAnimations(detail) {
    const cards = detail.querySelectorAll(".scroll-trigger");
    // Small delay to ensure CSS picks up the state change
    requestAnimationFrame(() => {
      cards.forEach((card) => {
        card.classList.remove("scroll-trigger--offscreen");
      });
    });
  }

  function closeMegaMenu(immediate = false) {
    if (!activeMegaDetail || isAnimating) return;

    const content = activeMegaDetail.querySelector(".mega-menu__content");
    const detailToClose = activeMegaDetail;
    activeMegaDetail = null;

    if (immediate || !content) {
      detailToClose.removeAttribute("open");
      resetCardAnimations(detailToClose);
      return;
    }

    isAnimating = true;
    content.style.opacity = "0";
    content.style.transform = "translateY(-1rem)";

    setTimeout(() => {
      detailToClose.removeAttribute("open");
      content.style.opacity = "";
      content.style.transform = "";
      resetCardAnimations(detailToClose);
      isAnimating = false;
    }, ANIMATION_DURATION);
  }

  function openMegaMenu(megaDetail) {
    if (isAnimating) return;

    if (activeMegaDetail && activeMegaDetail !== megaDetail) {
      closeMegaMenu(true);
    }

    megaDetail.setAttribute("open", "true");
    triggerCardAnimations(megaDetail);
    activeMegaDetail = megaDetail;
  }

  megaDetails.forEach((megaDetail) => {
    megaDetail.addEventListener("mouseenter", () => {
      openMegaMenu(megaDetail);
    });
  });

  document.addEventListener("mousemove", (event) => {
    if (!activeMegaDetail) return;

    const megaDetailRect = activeMegaDetail.getBoundingClientRect();
    const mouseY = event.clientY;
    const mouseX = event.clientX;
    let megaHeight = 0;

    const megaMenuContentElement = activeMegaDetail.querySelector(".mega-menu__content");
    if (megaMenuContentElement) {
      megaHeight = megaMenuContentElement.offsetHeight;
    }

    if (
      mouseY < megaDetailRect.top ||
      (mouseX < megaDetailRect.left && mouseY <= megaDetailRect.top) ||
      (mouseX > megaDetailRect.right && mouseY <= megaDetailRect.top) ||
      mouseY > 2.5 * megaDetailRect.top + megaHeight
    ) {
      closeMegaMenu();
    }
  });
})();
